/*
 *   File : edit-log.js
 *   Author : https://evoqins.com
 *   Description : Edit log list page
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// custom components
import { CustomDataTable } from '../../Components/DataTable';
import { APIService } from '../../Service';
import { EmptyScreen } from '../../Components/Others';

const TABLE_DATA = [
    {
        question: "What is your annual income from all sources?",
        edited_time: "23 Jul 2024",
        edited_by: "Admin",
        before_edit: "1Y-10Y",
        after_Edit: "0Y-10Y",
        detail: "Deleted"
    },
    {
        question: "What is your annual income from all sources?",
        edited_time: "23 Jul 2024",
        edited_by: "Admin",
        before_edit: "1Y-10Y",
        after_Edit: "0Y-10Y",
        detail: "New range added"
    },
    {
        question: "What is your annual income from all sources?",
        edited_time: "23 Jul 2024",
        edited_by: "Admin",
        before_edit: "",
        after_Edit: "",
        detail: "New range added"
    },
    {
        question: "What is your annual income from all sources?",
        edited_time: "23 Jul 2024",
        edited_by: "Admin",
        before_edit: "1Y-10Y",
        after_Edit: "0Y-10Y",
        detail: "New range added"
    },
];

const EditLog = () => {

    const navigate = useNavigate();
    const isRendered = useRef(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [editLog, setEditLog] = useState({});
    const [onPaginationChange, setOnPaginationChange] = useState(false);
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });

    }, [currentPage]);

    useEffect(() => {
        if (isRendered.current === true) {
            _viewEditLog();
        }
        isRendered.current = false;
    }, [])

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
        _viewEditLog(page_num)
    };

    // questions data table column 
    const TABLE_COLUMN = [
        {
            name: 'Question',
            cell: (row) =>
                <p className='truncate-third-line mb-0 e-text-smoky-black e-alt-font e-font-14 e-font-weight-400 line-height-24px'>
                    {row.question}
                </p>,
            width: "380px"
        },
        {
            name: 'Edited Time',
            selector: row => row.edited_time,
            width: "160px"
        },
        {
            name: 'Edited by',
            selector: row => row.edited_by,
            width: "120px"
        },
        {
            name: 'Before Edits',
            selector: row => row.before_edit ? row.before_edit : '-',
            width: "280px"
        },
        {
            name: 'After Edits',
            selector: row => row.after_edit ? row.after_edit : '-',
            width: "280px"
        },
        {
            name: 'Details',
            selector: row => row.details,
            width: "280px"
        }
    ];


    const _viewEditLog = (page_num = currentPage) => {
        let is_post = true;
        let url = 'manage-risk/view';
        let request = {
            "page_num": page_num,
            "page_size": 10
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setEditLog(response.data);
            }
            else {
                setEditLog({ data: [] });
            }
            setLoader(false);
            setOnPaginationChange(false);
        })
    };

    return (
        <section className='e-section-height pb-5' >
            <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                    <span className='text-decoration-hover-underline cursor-pointer'
                        onClick={() => navigate("/risk-assessment")}>Manage Risk Assessment</span> / <span className='e-font-weight-600'>View Edit Log</span>
                </p>
            </div>

            {/* Questions list */}
            <div className='padding-52px-lr margin--80px-top'>
                <div className='e-bg-white border-radius-16 padding-32px-tb '>
                    <div className='padding-32px-lr d-flex justify-content-between align-items-center'>
                        <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            Questions list
                        </h4>
                    </div>

                    {/* Question list table */}
                    {loader === true ?
                        <div className='d-flex align-items-center justify-content-center min-vh-100'>
                            <img src={require("../../Assets/Image/loader.gif")}
                                draggable={false}
                                width={80}
                                height={80}
                                alt='loader'
                                className='text-center' />
                        </div>
                        :
                        editLog.data.length > 0 ?
                            <div className='e-data-table-wrapper-default-updated pt-4 padding-32px-bottom'>
                                <CustomDataTable columns={TABLE_COLUMN}
                                    data={editLog.data}
                                    pagination={editLog.total_count > 10 ? true : false}
                                    paginationPerPage={10}
                                    lastPage={editLog.total_page}
                                    paginationDefaultPage={editLog.current_page}
                                    paginationTotalRows={editLog.total_count}
                                    onChangePage={_handleTablePageChange} />
                            </div>
                            :
                            <EmptyScreen
                                image={require('../../Assets/Image/NotFound/no-data.png')}
                                title='No results found'
                                description={`We couldn' t find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                            />
                    }

                </div>
            </div>
        </section>
    )
}

export default EditLog;
